export default {
    move_to_another_account_title: "Move to another account",
    move_to_another_account_account_from: "Account From",
    move_to_another_account_account_to: "Account To",
    move_to_another_account_keyfobs: "DriverID Tags",
    move_to_another_account_input: "ID#'s",
    move_to_another_account_identifier: "Identifier",
    move_to_another_account_account: "Account",
    move_to_another_account_driver: "Driver",
    move_to_another_account_model: "Model",
    move_to_another_account_change: "Move",
    move_to_another_account_no_devices_added: "No DriverID Tag added",
    move_to_another_account_device_is_already_added: "The DriverID Tag is already added",
    move_to_another_account_device_has_not_been_found: "The DriverID Tag has not been found",
    move_to_another_account_this_feature_is_not_available: "This feature is not available",
    move_to_another_account_single_success_message: "The DriverID Tag has been moved",
    move_to_another_account_multiple_success_message: "The DriverID Tag has been moved",
    move_to_another_account_error_message: "Unable to move the DriverID Tags due to an error",
    move_to_another_account_select_to_account: "Select the account destination first",
    move_to_another_account_restriction_to_move: "You cannot move DriverID Tags to accounts that are not active",
}

